import { Outlines } from '@react-three/drei';
import { ThreeEvent } from '@react-three/fiber';
import { observer } from 'mobx-react';

import { GroupState } from '../core/GroupState';
import { LoadableMeshState } from '../core/LoadableMeshState';
import { ObjectState } from '../core/ObjectState';
import Mesh from './Mesh';

interface GroupProps {
  state: GroupState;
  onObjectClick?: (object: ObjectState) => void;
  onNoneObjectClick?: () => void;
}

function Group({ onObjectClick, onNoneObjectClick, state }: GroupProps) {
  return (
    <group
      position={[state.position.x, state.position.y, state.position.z]}
      rotation={[state.rotation.x, state.rotation.y, state.rotation.z]}
      onClick={(event: ThreeEvent<MouseEvent>) => {
        event.stopPropagation();
        onObjectClick(state);
      }}
      onPointerMissed={onNoneObjectClick}
    >
      {state.objects.map((object, index) => {
        if (object instanceof LoadableMeshState) {
          return (
            <Mesh state={object} key={`${object.name}- ${object.materialName}-${index}}`}>
              {state.selected && (
                <>
                  <Outlines transparent={true} opacity={5} color="#32a98f" thickness={5} angle={0.05} />
                </>
              )}
            </Mesh>
          );
        }
      })}
    </group>
  );
}

export default observer(Group);
